import { jsxs as r, jsx as e } from "react/jsx-runtime";
const i = (l) => /* @__PURE__ */ r("svg", { width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-hidden": !0, focusable: !1, ...l, children: [
  /* @__PURE__ */ e("path", { fill: "currentColor", d: "M14.4711 17.7791V6.2002h3.2691C20.6451 6.2002 23 8.46823 23 11.266v1.4474c0 2.7977-2.3549 5.0657-5.2598 5.0657h-3.2691ZM1 17.7791c0-2.931 2.46705-5.307 5.51027-5.307 3.04322 0 5.51023 2.376 5.51023 5.307H1Z" }),
  /* @__PURE__ */ e("path", { fill: "currentColor", d: "M6.51027 12.4721c1.79827 0 3.25605-1.404 3.25605-3.13596 0-1.73193-1.45778-3.13594-3.25605-3.13594S3.25421 7.60421 3.25421 9.33614c0 1.73196 1.45779 3.13596 3.25606 3.13596Z" })
] });
export {
  i as default
};
//# sourceMappingURL=mit-id.js.map
